<template>
  <div class="deposit-print">
    <!-- {{flowHistoryData}} -->
    <div id="deposit-print">
      <div class="base-info">
        <div>
          <span>申请人：{{flowContent.creator}}</span>
          <span style="margin-left:50px">地区：{{projectData.district}}</span>
          <span style="margin-left:50px">流程单号：{{oneFlowHistory.SheetId}}</span>
        </div>
        <div>
          <span>申请时间：{{depositRefund.creationTime | filterTime}}</span>
        </div>
        <div>
          <div>项目名称：{{projectData.projectName}}</div>
          <div>项目编号：{{projectData.projectFull}}</div>
          <div>
            <span>开标日期：{{projectData.clMeetingRoom.beginTime | filterArticleTime}}</span>
            <span style="margin-left:50px">中标公告日期：{{projectData.winTime | filterArticleTime}}</span>
          </div>
          <div>采购人名称：{{ projectData.purchaserName }}</div>
        </div>
      </div>
      <table class="refund-table" cellspacing="0">
        <tr>
          <th>序号</th>
          <th style="width:150px;">网银序列号</th>
          <th style="width:150px;">报名单位</th>
          <th style="width:150px;">收款单位</th>
          <th style="width:50px">是否中标</th>
          <th style="width:150px">应退保证金</th>
          <th style="width:50px;">所投包组</th>
        </tr>
        <tr v-for="(item, index) in depositRefundData">
          <td>{{index+1}}</td>
          <td></td>
          <td>{{item.orders.ghfCompanyName}}</td>
          <td>{{item.orders.abpOrdersExp.bankName}}</td>
          <td>{{item.content | filterBidding}}</td>
          <td>{{item.orders.orderAmountTotal}}</td>
          <td>{{item.orders.abpOrdersExp.clGroupDb.groupNo}}</td>
        </tr>
      </table>
      <div>
        <div class="total-info">合计应退保证金：{{refundTotal}}</div>
        <div v-for="bidder in bidders" style="border-top:1px solid #ddd">
          <div>
            <span>中标单位：{{bidder.abpEnroll.companyName}}</span>
            <span style="margin-left:50px;">中标金额：{{bidder.winAmount}}</span>
            <span style="margin-left:50px;">中标包组：{{bidder.groupNumber}}</span>
            <span v-if="bidder.clGroupDb&&bidder.clGroupDb.isBuyer">（采购人付款）</span>
          </div>
          <div v-if="bidder.serviceCharge&&bidder.serviceCharge.length>0">
            <template v-for="serviceCharge in bidder.serviceCharge">
              <div>
                <span>服务费收取时间：{{serviceCharge.ordersDto.payTime | filterTime}}</span>
                <span style="margin-left:50px;">服务费收取金额：{{serviceCharge.ordersDto.orderAmountTotal}}</span>
                <span style="margin-left:50px;">合同存档日期：{{serviceCharge.pactTime | filterTime}}</span>
              </div>
            </template>
          </div>
        </div>
        <div style="margin-top:16px;">
        <span>采购人付款服务费<span style="color:#ff9900;"></span></span>
        <div v-for="serviceCharge in bidServiceCharge" style="border-top:1px solid #ddd;margin-bottom:20px;padding:5px 15px;">
          <div>
            <span>公司名称：{{serviceCharge.companyName}}</span>
            <span style="margin-left:65px;">信用代码：{{serviceCharge.companyNo}}</span>
          </div>
          <span>服务费收取时间：{{serviceCharge.ordersDto.payTime | filterTime}}</span>
          <span style="margin-left:65px;">服务费收取金额：{{serviceCharge.ordersDto.orderAmountTotal}}</span>
          <span style="margin-left:65px;">合同存档日期：{{serviceCharge.pactTime | filterTime}}</span>
        </div>
      </div>
      </div>
      <table cellspacing="0">
        <tr>
          <th style="width:150px;">操作类型</th>
          <th style="width: 150px;">操作人</th>
          <th style="width:80px;">执行结果</th>
          <th style="width:200px;">操作时间</th>
          <th style="width:150px;">备注</th>
        </tr>
        <tr v-for="flow in flowHistoryData">
          <td>{{flow.ActivityShowName}}</td>
          <td>{{flow.RealName}}</td>
          <td>{{flow.CompletedType | filterHistoryStatus}}</td>
          <td>{{flow.CompletedTime | filterFlowTime}}</td>
          <td>{{flow.Opinion}}</td>
        </tr>
      </table>
    </div>
    <Button @click="print" type="primary" style="margin-top:10px;">打印</Button>
  </div>
</template>

<script>
import x2js from 'x2js'
import { formatDate } from '@/lib/tool';

export default {
  name: 'depositPrint',
  props: {
    projectData: {
      type: Object
    },
    depositRefundData: {
      type: Array,
      required: true,
    },
    flowHistoryData: {
      type: Array,
      required: true
    },
    bidders: {
      type: Array
    },
    bidServiceCharge: {
      type: Array
    }
  },
  computed: {
    flowContent() {
      if (!this.depositRefundData || !this.depositRefundData[0]) {
        return {}
      }
      const x2Json = new x2js()
      const xmlJSON = x2Json.xml2js(this.depositRefundData[0].content)
      return xmlJSON.root
    },
    depositRefund() {
      if (!this.depositRefundData || !this.depositRefundData[0]) {
        return {
          creationTime: ''
        }
      }
      return this.depositRefundData[0]
    },
    oneFlowHistory() {
      if (this.flowHistoryData.length === 0) {
        return {
          SheetId: ''
        }
      }
      return this.flowHistoryData[0]
    },
    refundTotal() {
      if (this.depositRefundData.length === 0) {
        return 0
      }
      let total = 0
      this.depositRefundData.forEach(deposit => {
        total += deposit.orders.orderAmountTotal
      })
      return total
    }
  },
  mounted () {
    console.log(this.projectData)
  },
  data() {
    return {
    }
  },
  methods: {
    print() {
      const printTitle = `${this.projectData.projectShort}-借支回收证明`
      this.printPartial(document.getElementById('deposit-print'), { title: printTitle }, '#deposit-print')
    },
    printPartial(dom, { title= document.title,}= {}, specialStyle = '') {
      if (!dom) return;
      let copyDom = document.createElement('span');
      const styleDom = document.querySelectorAll('style');
      const titleDom = document.createElement('title');
      titleDom.innerText = title;

      copyDom.appendChild(titleDom);
      Array.from(styleDom).forEach(item=> {
        if (item.childNodes[0].nodeValue.indexOf(specialStyle) !== -1) {
          copyDom.appendChild(item.cloneNode(true));
        }
      });
      const childNodes = dom.childNodes;
      copyDom.appendChild(dom.cloneNode(true));

      const htmlTemp = copyDom.innerHTML;
      copyDom = null;
      const iframeDom = document.createElement('iframe');
      const attrObj = {
        height: 0,
        width: 0,
        border: 0,
        wmode: 'Opaque'
      };
      const styleObj = {
        position: 'absolute',
        top: '-999px',
        left: '-999px',
      };
      Object.entries(attrObj).forEach(([key, value])=> iframeDom.setAttribute(key, value));
      Object.entries(styleObj).forEach(([key, value])=> iframeDom.style[key] = value);
      document.body.insertBefore(iframeDom, document.body.children[0]);
      const iframeWin = iframeDom.contentWindow;
      const iframeDocs = iframeWin.document;
      // iframeDocs.write(`<!doctype html>`);
      // iframeDocs.write(htmlTemp);
      iframeDocs.body.innerHTML = htmlTemp
      iframeWin.focus();
      iframeWin.print();
      // document.body.removeChild(iframeDom);
      // dom.style.display = 'none'
    }
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return '-'
      }
      return formatDate(val)
    },
    filterArticleTime(val) {
      if (!val) {
        return '无挂网日期'
      }
      return formatDate(val).split(' ')[0]
    },
    filterBidding(content) {
      if (!content) {
        return ''
      }
      const x2Json = new x2js()
      const xmlJSON = x2Json.xml2js(content)
      return xmlJSON.root.isBidding
    },
    filterHistoryStatus(val) {
      let result = '未知状态'
      switch (val) {
        case 'StartWorkflow':
          result = '发起'
          break
        case 'Approval':
          result = '通过'
          break
        case 'Reject':
          result = '驳回'
          break
        case '':
          result = '待办'
          break
      }
      return result
    },
    filterFlowTime(val) {
      if (!val) {
        return ''
      }
      let time = parseInt(val.slice(6, 19))
      time = formatDate(time).split(' ')[0]
      return time
    }
  }
}
</script>

<style lang="less" scoped>
// #deposit-print {
//   .base-info {
//     line-height: 20px;
//     margin-bottom: 10px;
//   }
//   table {
//     text-align: center;
//     td, th {
//       border: 1px solid #ddd;
//     }
//   }
//   .deposit-print {
//     div {
//       padding: 5px 0;
//     }
//   }
//   .total-info {
//     margin: 10px 0;
//   }
// }
</style>
